/*-----------------------------------------------------------------------------------
 * Kingsoft Office Enterprise Cloud Services.
 * Copyright (c) Kingsoft Office,All rights reserved.
 *-----------------------------------------------------------------------------------*/
import WebReporter from '@dw/js-sdk/dist/WebReporter.js'
import { isIframe } from '@util/index'
import createReporter from '@quick/service-reporter'
import clientApi from '@plus/client-connect'
import { getIsLogin } from '@services/index'

interface DwIns {
  onEvent: (arg0: string, arg1: Record<string, any>) => void
  setAccountId: (arg0: string) => void
  setAppKey: (arg0: string) => void
  reportDelay?: (arg0: string, arg1: Record<string, any>) => void
  report?: (arg0: string, arg1: Record<string, any>) => void
}

let clientVersion: any = undefined
const getClientVersion = async () => {
  // iframe不兼容，直接return iframe
  if (isIframe()) {
    clientVersion = 'iframe';
    return clientVersion
  }
  if (clientVersion !== undefined) return clientVersion;
  try {
    const clientName = clientApi.getCurrentClient()
    const { version } = (await clientApi.getAppVersion({ clientName })) || {}
    clientVersion = version || null
    return clientVersion
  } catch (e) {
    clientVersion = null
    return clientVersion
  }
}

let _did
try {
  _did = localStorage.getItem('dw_store_device_id_key')
} catch {
  _did = ''
}
let userid: string | number = 0
let _company_id: string | number= ''
let serviceReporter:any = null

let isTest = import.meta.env.NODE_ENV === 'test'

let formateParams = params => {
  let res = {}
  Object.keys(params).forEach(key => {
    if (params[key] === undefined || params[key] === null) return
    res[key] = params[key]
  })
  return res
}
let $dw

if (!isTest) {
  let isTouristStatus = false // 游客状态
  $dw = new WebReporter({
    id: 'register',
    client: clientApi.getCurrentClient()
  }) as DwIns
  $dw.setAppKey('e8660369b684c2e5')
  const _app_version = import.meta.env.VUE_APP_RELEASE_VERSION || ''
  const useragent = window.navigator.userAgent.toLowerCase()
  $dw.report = async function (name, params, endpoint = 'all') {
    const client_version = await getClientVersion()
    // 去除params为undefined和null的值
    params = formateParams(params)
    // 判断是否有userid
    if (!userid && !isTouristStatus) {
      try {
        const userInfo = await getIsLogin()
        userid = userInfo.data.userid
        _company_id = userInfo.data.companyid
      } catch (e) {
        isTouristStatus = true
      }
    }

    if (!serviceReporter) {
      $dw.setAccountId(userid)
      window.APM.setConfig({ accountId: userid }) // kapm信息
      // @ts-ignore
      serviceReporter = createReporter(userid)
    }

    if (endpoint === 'all' || endpoint === 'server') {
      serviceReporter && serviceReporter(
        name,
        Object.assign(
          {
            _did,
            _company_id,
            _app_version,
            useragent,
            client_version,
          },
          params
        )
      )
    }
    if (endpoint === 'all' || endpoint === 'dw') {
      $dw.onEvent(
        name,
        Object.assign(
          {
            userid,
            _company_id,
            _app_version,
            useragent,
            client_version,
          },
          params
        ),
      )
    }
  }

  $dw.reportDelay = (name, params) => {
    setTimeout(() => {
      $dw.report && $dw.report(name, params)
    }, 1000)
  }
} else if (isTest) {
  $dw = {
    report: async function () {},
  }
}

export default $dw
